import { Tuple } from "~/tools/tuple";

const QUERY_NAMESPACE = Tuple("metrics-drawer");

export { QUERY_NAMESPACE };
